import { styled } from "@mui/material/styles"
import Radio, { RadioProps } from "@mui/material/Radio"
import TickIcon from "components/atoms/_icons/TickIcon"

interface CustomRadioProps extends RadioProps {
}

export default function RadioButton(props: CustomRadioProps) {

  return (
    <StyledRadio
      sx={{ "&:hover": { bgcolor: "transparent" } }}
      disableRipple
      color="default"
      checkedIcon={<TickIcon/>}
      icon={<></>}
      {...props}
    />
  )
}

const StyledRadio = styled(Radio)(({ theme }) => ({
  width: "22px",
  height: "22px",
  borderRadius: "50%",
  padding: 0,
  border: `1px solid ${theme?.palette?.gray["7"]}`,
  transition: "0.1s",
  backgroundColor: theme?.palette?.gray["5"],

  "&.Mui-checked": {
    backgroundColor: `${theme?.palette?.success["4"]} !important`,
    border: `1px solid ${theme?.palette?.success["4"]}`,

    "& svg": {
      width: "12px",
      height: "12px"
    },
    "& path": {
      fill: "#FFFFFF"
    }
  }
}))
